import {axiosGetHandler, axiosPostHandler} from './config'
import { getParams, extractAPIValues, getUrlParam } from '_lib/utils/utils'
const {BASE_API, BASE_XHH} = extractAPIValues()
function handleArgs(v) {
	return {
		...v,
		_notip: true
	}
}

// 数据上报
export function reportData (event_type, addition = {}) {
	let url = BASE_API + '/chatroom/v2/report'
	for (let k in addition) { // 接口中addition只能传string
		addition[k] = String(addition[k])
	}

	// 如果是网页端并且origin参数是undefined
	if(!process.env.IS_CLIENT && addition['origin'] === undefined) {
		addition['origin'] = getUrlParam('origin')
	}

	let args = {
		event_type,
		addition: addition
	}
	return axiosPostHandler(url, {}, handleArgs(args))
}

// 登录上报
export function reportLogin (args, addition = {}) {
	let param = {
		type: ''
	}
	switch (args) {
		case 'login':
			param.type = 0
			break
		case 'invite':
			param.type = 1
			break
		case 'token':
			param.type = 2
			break
		default:
			param.type = 0
			break
	}
	param = {
		...param,
		...addition,
	}
	let {qz_gdt, click_ext} = getParams()
	param.qz_gdt = qz_gdt
	param.click_ext = click_ext
	param.origin = getUrlParam('origin')
	let url = BASE_API + '/chatroom/report/login_report'
	return axiosGetHandler(url, handleArgs(param))
}

// 语音时长上报
export function reportChatTime (args) {
	let url = BASE_API + '/chatroom/v2/report/audio'
	return axiosGetHandler(url, handleArgs(args))
}

// 接入语音成功上报
export function reportJoinChat (args) {
	let url = BASE_API + '/chatroom/report/audio_report'
	return axiosGetHandler(url, handleArgs(args))
}

// 复制邀请链接上报
export function reportCopyInvite (args) {
	let url = BASE_API + '/chatroom/report/copy_invite_code'
	return axiosGetHandler(url, handleArgs(args))
}

// 组队大厅曝光上报
export function reportViewTeam (args) {
	let url = BASE_API + '/chatroom/report/view_team'
	return axiosGetHandler(url, handleArgs(args))
}

// 发布组队贴上报
export function reportPublishTeam (args) {
	let url = BASE_API + '/chatroom/report/create_team'
	return axiosGetHandler(url, handleArgs(args))
}

// bot命令上报
export function reportBotCommand (addition = {}) {
	let url = BASE_API + '/chatroom/v2/report/handle'
	for (let k in addition) { // 接口中addition只能传string
		addition[k] = String(addition[k])
	}
	let args = {
		event_type: 'bot_command_used',
		addition
	}
	return axiosPostHandler(url, {}, handleArgs(args))
}
export function reportRender (type, addition = {}) {
  if (window._reportEnterRoom) {
		const location = window.location
		let pathname = process.env.IS_CLIENT ? location.hash.slice(1) : location.pathname
		if (pathname == '/app/room/' + window._reportEnterRoom.room_id) {
			let timeDiff = Math.round(Date.now() - window._reportEnterRoom.click_time)
			clientLog(`${type} render time - time_diff: ${timeDiff} room_info: ${JSON.stringify(window._reportEnterRoom)}; addition: ${JSON.stringify(addition)}`)
			console.log('render time: ' + type, timeDiff)
			reportData('render:' + type, Object.assign({
				time: timeDiff,
				room_id: window._reportEnterRoom.room_id,
				entrance: window._reportEnterRoom.entrance
			}, addition))
		}
	}
}

// 上报执行小程序的方式
export function reportExecMp (addition = {}, id) {
	if (!addition.id) {
		addition.id = id
		addition.type = 'protocol-exec'
	}
	reportData('mini_program:click', addition);
}

// 上报广告查看详情
export function reportAdvertisementCheck (addition) {
	reportData('advertisement_check', addition);
}

// 上报广告不显示
export function reportAdvertisementClose (addition) {
	reportData('advertisement_close', addition);
}

// 上报首页点击语音包合小程序平台
export function reportHomeClick (addition) {
	reportData('home_click', addition);
}

// 上报新手教程打开
export function reportNewMemberGuide(addition){
	reportData('use_new_member_guide', addition);
}

/**
 * 上报进入房间的时间
 * 从调用$jump开始， 总共两个时间段
 * 1. 从调用$jump到进入房间
 * 2. 从进入房间到进入频道
 * 3. 添加当前房间是否存在默认频道的数据
 */
export function reportEnterRoomChannelTiming (addition) {
	reportData('enter_room_channel_timing', addition)
}

// 上报创建房间活动
export function reportCreateRoomActivity (addition) {
    reportData('create-room-activity', addition)
}

// 上报活动轮播组件操作
export function reportActIntervalOperation (addition) {
    reportData('act_interval_operation', addition)
}

// 上报活动列表操作
export function reportActListOperation (addition) {
    reportData('act_list_operation', addition)
}

// 上报活动详情操作
export function reportActDetailOperation (addition) {
    reportData('act_detail_operation', addition)
}

// 上报点击房间更多菜单跳转bot的行为
export function reportJumpBotPlatform(addition) {
	reportData('click:room_more_menu_jump_bot', addition)
}